import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconIncrease$1 = /*@__PURE__*/ proxyCustomElement(class WppIconIncrease extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-increase", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12.375 3.125C12.375 2.71079 12.7108 2.375 13.125 2.375H16.4583C16.8725 2.375 17.2083 2.71079 17.2083 3.125V6.45833C17.2083 6.87255 16.8725 7.20833 16.4583 7.20833C16.0441 7.20833 15.7083 6.87255 15.7083 6.45833V4.93566L13.2387 7.40533C13.098 7.54598 12.9072 7.625 12.7083 7.625H11.4663L10.4348 9.3442C10.2992 9.57011 10.0551 9.70833 9.79166 9.70833H8.13297L7.10144 11.4275C6.9659 11.6534 6.72177 11.7917 6.45832 11.7917H4.79963L3.76811 13.5109C3.555 13.8661 3.0943 13.9812 2.73912 13.7681C2.38393 13.555 2.26876 13.0943 2.48187 12.7391L3.73187 10.6558C3.86741 10.4299 4.11154 10.2917 4.37499 10.2917H6.03368L7.0652 8.57246C7.20075 8.34656 7.44488 8.20833 7.70832 8.20833H9.36701L10.3985 6.48913C10.5341 6.26322 10.7782 6.125 11.0417 6.125H12.3977L14.6477 3.875H13.125C12.7108 3.875 12.375 3.53921 12.375 3.125ZM16.4583 8.20833C16.8725 8.20833 17.2083 8.54412 17.2083 8.95833V16.875C17.2083 17.2892 16.8725 17.625 16.4583 17.625C16.0441 17.625 15.7083 17.2892 15.7083 16.875V8.95833C15.7083 8.54412 16.0441 8.20833 16.4583 8.20833ZM13.125 9.04167C13.5392 9.04167 13.875 9.37745 13.875 9.79167V16.875C13.875 17.2892 13.5392 17.625 13.125 17.625C12.7108 17.625 12.375 17.2892 12.375 16.875V9.79167C12.375 9.37745 12.7108 9.04167 13.125 9.04167ZM9.79166 10.7083C10.2059 10.7083 10.5417 11.0441 10.5417 11.4583V16.875C10.5417 17.2892 10.2059 17.625 9.79166 17.625C9.37744 17.625 9.04166 17.2892 9.04166 16.875V11.4583C9.04166 11.0441 9.37744 10.7083 9.79166 10.7083ZM6.45832 12.7917C6.87254 12.7917 7.20832 13.1275 7.20832 13.5417V16.875C7.20832 17.2892 6.87254 17.625 6.45832 17.625C6.04411 17.625 5.70832 17.2892 5.70832 16.875V13.5417C5.70832 13.1275 6.04411 12.7917 6.45832 12.7917ZM3.12499 15.2917C3.5392 15.2917 3.87499 15.6275 3.87499 16.0417V16.875C3.87499 17.2892 3.5392 17.625 3.12499 17.625C2.71078 17.625 2.37499 17.2892 2.37499 16.875V16.0417C2.37499 15.6275 2.71078 15.2917 3.12499 15.2917Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-increase-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-increase", "wpp-icon-increase-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-increase-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-increase-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconIncrease$1);
      }
      break;
  } });
}

const WppIconIncrease = WppIconIncrease$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconIncrease, defineCustomElement };
